import Toaster from "./Toaster";
import ToastContext from "./ToastService";
import { useState } from "react";

export default function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([])
    const open = (component, icon, type, timeout = 3000) => {
        const id = Date.now()
        setToasts(toasts => [...toasts, { id, component, icon, type }])
        setTimeout(() => close(id), timeout)
        return id
    }
    const close = (id) => setToasts(toasts => toasts.filter(toast => toast.id !== id))
    return (
        <ToastContext.Provider value={{ open, close }}>
            {children}
            <div className="fixed space-y-2 bottom-4 right-4 z-[100]">
                {toasts.map(({ id, component, icon, type }) => (
                    <Toaster close={close} id={id} icon={icon} type={type}>
                        {component}
                    </Toaster>
                ))}
            </div>
        </ToastContext.Provider>
    )
}
